import React from 'react'
import PropTypes from 'prop-types'
import {TAB_BASIC_DATA} from '../../state/detail/const'
import currentUserHasAccess from '../../../../util/widget-helper'
import { CUSTOMER_ADD_COMMENT, CUSTOMER_COMMENT_LIST } from '../../ui-definition/customer-ui'

const TabHeaderItem = ({tab, changeActiveTab, children, name}) => {
    return (
        <li
            className={tab === name ? 'active' : ''}
            onClick={() => {
                changeActiveTab(name)
            }}
        >
            {children}
        </li>
    )
}


const CustomerTabHeader = ({customer, changeActiveTab, tab}) => {
    if (customer === null) {
        return null
    }

    const canSeeCommentsTab = currentUserHasAccess(CUSTOMER_COMMENT_LIST) || currentUserHasAccess(CUSTOMER_ADD_COMMENT)

    return (

        <div className="tabs-wrapper">
            <ul className="nav-tabs">
                <TabHeaderItem
                    tab={tab}
                    changeActiveTab={changeActiveTab}
                    name={TAB_BASIC_DATA}
                >
                    Basic Data
                </TabHeaderItem>
                <TabHeaderItem
                    tab={tab}
                    changeActiveTab={changeActiveTab}
                    name="medical"
                >
                    Medical
                </TabHeaderItem>
                <TabHeaderItem
                    tab={tab}
                    changeActiveTab={changeActiveTab}
                    name="photos"
                >
                    Photos
                </TabHeaderItem>
                <TabHeaderItem
                    tab={tab}
                    changeActiveTab={changeActiveTab}
                    name="accounting"
                >
                    Accounting
                </TabHeaderItem>
                <TabHeaderItem
                    tab={tab}
                    changeActiveTab={changeActiveTab}
                    name="files"
                >
                    Files
                </TabHeaderItem>
                {canSeeCommentsTab &&
                    (<TabHeaderItem
                        tab={tab}
                        changeActiveTab={changeActiveTab}
                        name="comments"
                    >
                        Comments
                    </TabHeaderItem>)
                }
            </ul>
        </div>


    )
}

CustomerTabHeader.propTypes = {
    customer: PropTypes.object,
    changeActiveTab: PropTypes.func.isRequired,
    tab: PropTypes.string.isRequired,
}


export default CustomerTabHeader



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/CustomerTabHeader.js